module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10033.70059bcd.jpg";